import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useLiveAnnotation } from "../../../hooks/use-live-annotation";
import ControlPanelButton from "../../model-viewer/control-panel/components/control-panel-button";

interface CloseLiveAnnotationControlButtonProps {
  expired?: boolean;
  urlIndex?: number;
  disabled?: boolean;
  liveAnnotationChanged?: (showAnnotation: boolean) => void;
}

/**
 * Control component for activating/deactivating live annotation in control bars
 * Renders as a ControlButton without text labels
 */
const CloseLiveAnnotationControlButton: React.FC<CloseLiveAnnotationControlButtonProps> = ({
  expired = false,
  urlIndex,
  disabled,
  liveAnnotationChanged,
}) => {
  const {
    onClick,
    isDisabled,
    tooltipText,
  } = useLiveAnnotation({
    expired,
    urlIndex,
    disabled,
    liveAnnotationChanged,
  });

  return (
    <ControlPanelButton
      disabled={isDisabled}
      onClick={onClick}
      activeColor={"#c62828"}
      icon={<CloseIcon color="action" />}
      activeTooltip={tooltipText}
    />
  );
};

export default CloseLiveAnnotationControlButton;
